import { z } from "zod";
import { baseSearchSchema } from "../-search-params";

export const onboardingSearchSchema = z.object({
	...baseSearchSchema.shape,
});

export type OnboardingSearch = z.infer<typeof onboardingSearchSchema>;

export const validateOnboardingSearch = (search: Record<string, unknown>): OnboardingSearch => {
	return onboardingSearchSchema.parse(search);
};
